import { format } from 'date-fns';

const timeZonePattern = /[zZ]|[+-]\d{2}:?\d{2}$/;

export const parseApiDate = (value: string | Date): Date => {
  if (value instanceof Date) {
    return value;
  }

  if (!value) {
    return new Date(NaN);
  }

  const normalized = timeZonePattern.test(value) ? value : `${value}Z`;
  return new Date(normalized);
};

export const toLocalInputValue = (value: Date) => format(value, "yyyy-MM-dd'T'HH:mm");

export const toUtcIso = (value: Date) => value.toISOString();
